import keys from 'keys';

const getLogoutURL = () => {
    return keys.AUTH_URL + `/logout?redirect=${encodeURI(window.location.href)}`
}

export default getLogoutURL;